import { createContext, useContext, useMemo } from 'react'
import { useSelector } from 'react-redux'

import {
  DefaultTheme,
  ThemeProvider as SCThemeProvider,
} from 'styled-components'
import { selectCohortID } from '~/shared/store/common/selects'
import { BIOLOGY_THEME } from '~/shared/styles/theme'

import { getTheme } from './helpers/getTheme'

type TThemeContextProps = {
  theme: DefaultTheme
  mode: DefaultTheme['mode']
}

const ThemeContext = createContext<TThemeContextProps>({
  theme: BIOLOGY_THEME,
  mode: BIOLOGY_THEME.mode,
})

export const ThemeProvider = ({ children }) => {
  const cohort = useSelector(selectCohortID)
  const theme = getTheme(cohort)

  const value = useMemo(
    () => ({
      theme,
      mode: theme.mode,
    }),
    [theme],
  )

  return (
    <ThemeContext.Provider value={value}>
      <SCThemeProvider theme={{ ...value.theme }}>{children}</SCThemeProvider>
    </ThemeContext.Provider>
  )
}

export const useThemeContext = () => {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useThemeContext must be used within a ThemeProvider')
  }
  return context
}
